import React from "react";
import SubChapterCard from "../SubChapterCard";
import BrokerageMap from "../BrokerageMap";
import {getData, manageData} from "../../requests/CRUD";
import {getBase64, sortArray, toMediaUrl, toMediaPath} from "../../utils";
import Icon from "../Icon";
import svgSortAsc from "../../svgs/arrow-up.svg";
import {TRAINING} from "../../consts/tables";
import {existingFileError, existingFileErrorMessage, missingFileError, videoImage} from "../../consts/consts";
import { removeFile, uploadFile } from "../../requests/fileRequests";
import isEqual from "lodash.isequal";
import {getChapterColorBySlug} from "../Training/chapterColors";
import LinkComp from "../LinkComp";
import ConfirmationDialog from "../ConfirmDialog";
import ImageCropperDialog from "../ImageCropperDialog/ImageCropperDialog";

import { can, canEditTraining } from "../../access";

let cloneDeep = require('lodash.clonedeep');

const FOLDER = 'training'

export default class ChapterPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            originalChapters: [],
            chapters: [],
            brokerageChapters: [],
            title: '',
            hasVideo: false,
            videoLink: '',
            backButton: '',
            // startInEdit: an empty chapter reached via ContentPage's "Add
            // Sub-chapters" opens straight in edit mode to add the first one.
            isEdit: Boolean(props.startInEdit),
            newChapter: {visible:false},
            uploadedImage: null,
            error: null,
            lastModified: null,
            previousIndexes: [],
            // id of the training card awaiting delete confirmation (null = dialog closed)
            pendingDeleteId: null,
            // {src, name, id} while the crop dialog is open for a freshly picked image
            cropper: null
        };

        this.toggleEdit = this.toggleEdit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.cancelChanges = this.cancelChanges.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.validateSelectedFile = this.validateSelectedFile.bind(this);
        this.processImageFile = this.processImageFile.bind(this);
        this.handlePasteImage = this.handlePasteImage.bind(this);
        this.uploadPhoto = this.uploadPhoto.bind(this);
        this.removePhoto = this.removePhoto.bind(this);
        this.deleteCard =  this.deleteCard.bind(this);
        this.confirmDeleteCard = this.confirmDeleteCard.bind(this);
        this.handleCropConfirm = this.handleCropConfirm.bind(this);
        this.handleCropCancel = this.handleCropCancel.bind(this);
    }

    componentDidMount() {
        this.fetch(this.props.params);
        const topSlug = this.props.params && (this.props.params.slug || Object.values(this.props.params)[0]);
        if (topSlug === 'brokerage-continuum') {
            getData({
                tableCode: TRAINING,
                options: {
                    filter: [
                        { text: '', code: 'DELETED', type: 'null' },
                        { text: 'brokerage-continuum', code: 'PARENT_SLUG', type: 'exact' },
                    ],
                    filterType: 'and',
                },
            }).then(res => {
                if (res && res.success && Array.isArray(res.data) && res.data.length) {
                    const brokerageChapters = sortArray(
                        res.data.map(c => ({ id: c.SLUG, name: c.NAME, index: parseInt(c.INDEX) })),
                        'index');
                    this.setState({brokerageChapters});
                }
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(this.props.params, nextProps.params))
            this.fetch(nextProps.params);
    }

    toggleEdit() {
        this.setState(prevState => {
            return {
                isEdit: !prevState.isEdit
            }
        });
    }

    getNewSlug(title){
        return title.toString().toLowerCase()
                .replace(/[&]/g,'and')              //replace '&' with 'and'
                .replace(/<br\/>|\s(-|\/)\s/g,'')  // remove ' - ', ' / ', '</br>'
                .replace(/[^\w\s\/\-]/g, '')        //replace punctuation characters except '/' and '-'
                .replace(/[\/ ]/g, "-");            //replace ' ' and '/' with '-'
    }

    saveChanges() { 
        const params = this.props.params;
        const keys = Object.keys(params);
        const slugs = params && keys.length ? keys.map(key => params[key]) : [];
        const subchapterParentSlug = slugs.join('/');

        const chapters = cloneDeep(this.state.chapters);

        const newChapter = cloneDeep(this.state.newChapter);
        let chapterToSave = {};
        if (newChapter && newChapter.visible) {
            const title = (newChapter.title || '').trim();
            if (!title) {
                this.setState({error: 'Give the new module a title'});
                return;
            }
            const newChapterSlug = this.getNewSlug(title);
            if (chapters.some(ch => ch.slug === newChapterSlug)) {
                this.setState({error: `"${title}" is already a module in this section`});
                return;
            }
            const maxIndex = chapters.length ? Math.max(...chapters.map(ch => ch.index)) + 1 : 1;
            const requestedIndex = parseInt(newChapter.index);
            chapterToSave = {
                PARENT_SLUG: subchapterParentSlug,
                SLUG: newChapterSlug,
                INDEX: requestedIndex >= 1 && requestedIndex <= maxIndex ? requestedIndex : maxIndex,
                PHOTO: newChapter.img,
                NAME: title,
            }
        }
        let chaptersToUpdate = [];
        let indexIncrement = 0;
        let newChapters = [];
        chapters.map((chapter) => {
            if (chapterToSave && chapterToSave.INDEX && chapter.index === chapterToSave.INDEX) {
                indexIncrement++;
                chaptersToUpdate.push(chapterToSave);
                newChapters.push({
                    id: chapterToSave.ARCIMEDES_ROW_ID,
                    slug: chapterToSave.SLUG,
                    title: chapterToSave.NAME,
                    index: parseInt(chapterToSave.INDEX),
                    img: toMediaUrl(chapterToSave.PHOTO),
                });
            }
            //chapter is modified
            if (indexIncrement !== 0 || !this.state.originalChapters.some(ch => isEqual(ch,chapter))){
                chaptersToUpdate.push({
                    ARCIMEDES_ROW_ID: chapter.id ? chapter.id : null,
                    PARENT_SLUG: subchapterParentSlug,
                    SLUG: this.getNewSlug(chapter.slug),
                    INDEX: parseInt(chapter.index) + indexIncrement,
                    PHOTO: toMediaPath(chapter.img),
                    NAME: chapter.title
                })
                newChapters.push({...chapter, slug: this.getNewSlug(chapter.slug), index:parseInt(chapter.index) + indexIncrement});
            }
            else
                newChapters.push(chapter);
        });

        if(this.state.originalChapters.length != chapters.length){
            const deletedElements = this.state.originalChapters.filter(ch1 => !chapters.some(ch2 => ch2.id === ch1.id));

            deletedElements.forEach((chapter) => {
                chaptersToUpdate.push({
                    ARCIMEDES_ROW_ID: chapter.id ? chapter.id : null,
                    PARENT_SLUG: subchapterParentSlug,
                    SLUG: this.getNewSlug(chapter.slug),
                    INDEX: parseInt(chapter.index) + indexIncrement,
                    PHOTO: toMediaPath(chapter.img),
                    NAME: chapter.title,
                    DELETED: 1
                })
            });
        }
                
        if (indexIncrement === 0 && Object.keys(chapterToSave).length > 0) {
            chaptersToUpdate.push(chapterToSave);
            newChapters.push({
                id: chapterToSave.ARCIMEDES_ROW_ID,
                slug: chapterToSave.SLUG,
                title: chapterToSave.NAME,
                index: chapterToSave.INDEX,
                img: toMediaUrl(chapterToSave.PHOTO),
            });
        }

        if ((newChapter && newChapter.visible) || !isEqual(this.state.originalChapters,chapters))
            manageData({
                tableCode: TRAINING,
                data: chaptersToUpdate.length ? chaptersToUpdate : chapters
            }).then(res => {
                if (res && res.success) {
                    const savedChapter = chapterToSave.SLUG
                        ? res.data.find(chapter => chapter.SLUG === chapterToSave.SLUG)
                        : null;
                    if (savedChapter) {
                        newChapters = sortArray([...newChapters.filter(ch => ch.slug !== chapterToSave.SLUG), {
                            id: savedChapter.ARCIMEDES_ROW_ID,
                            slug: savedChapter.SLUG,
                            title: savedChapter.NAME,
                            index: parseInt(savedChapter.INDEX),
                            img: toMediaUrl(savedChapter.PHOTO),
                        }],'index');
                    }
                    let newChapter = {visible: false};
                    const previousIndexes = savedChapter ?
                        [
                            ...this.state.previousIndexes,
                            {
                                id: savedChapter.ARCIMEDES_ROW_ID,
                                index: parseInt(savedChapter.INDEX)
                            }
                        ] : this.state.previousIndexes;
                    this.setState({
                        chapters: newChapters,
                        originalChapters: newChapters,
                        newChapter,
                        previousIndexes,
                        error: null
                        },
                        this.toggleEdit
                    );
                    return;
                }
                this.setState({
                    error: res && res.message ? res.message : "Unspecified error",
                });
            });

        else if (!newChapter || isEqual(this.state.originalChapters, chapters))
            this.toggleEdit();
    }
    
    handleInputBlur(key, value, isNewChapter=false){
        let chapters = cloneDeep(this.state.chapters);
        if (!isNewChapter) {
            const id = key.split('_')[0];
            const newKey = key.split('_')[1];
            const newValue = Number(value);
            let previousIndexes = cloneDeep(this.state.previousIndexes)
            let currentChapterInfo = previousIndexes.find((ch) => ch.id === id);
            const previousIndex = currentChapterInfo.index;

            if (newKey === 'index' && previousIndex && newValue !== previousIndex) {
                chapters.filter((ch) => ch.id !== id).map((chapter) => {
                    if (chapter.index <= newValue && chapter.index > previousIndex) {
                        chapter.index--;
                        previousIndexes.find((o)=> o.id === chapter.id).index = chapter.index;
                    }
                    else if (chapter.index >= newValue && chapter.index < previousIndex) {
                        chapter.index++;
                        previousIndexes.find((o) => o.id === chapter.id).index = chapter.index;
                    }
                })
                chapters = sortArray(chapters, 'index');
                currentChapterInfo.index = newValue;
                previousIndexes = [...previousIndexes.filter(ch => ch.id !== id), currentChapterInfo]
                this.setState({chapters, previousIndexes});
            }
        }
    }

    handleInputChange(key, value, isNewChapter = false){
        if (isNewChapter) {
            let newChapter = cloneDeep(this.state.newChapter);
            newChapter[key] = value;
            this.setState({newChapter})
        } else {
            let chapters = cloneDeep(this.state.chapters);
            const id = key.split('_')[0];
            const newKey = key.split('_')[1];
            let currentChapter = chapters.find((el) => el.id === id);
            if (newKey === 'index') {
                currentChapter[newKey] = Number(value);
            } else
                currentChapter[newKey] = value;
            this.setState({chapters});
        }
    }
    
    fetch(params) {
        const keys = Object.keys(params);
        const slugs = params && keys.length ? keys.map(key => params[key]) : [];
        const subchapterParentSlug = slugs.join('/');
        const slug = slugs[slugs.length - 1] || '';
        const parentChapterSlug = slugs[slugs.length - 2] || '';
        slugs.pop();
        const parentSlug = slugs.join('/') || 'training';
        let parentChapterParentSlug = ''
        if (slugs.length) {
            slugs.pop();
            parentChapterParentSlug = slugs.join('/') || 'training';
        }
        const hasVideo = parentSlug === 'brokerage-continuum';

        const requests = [
            getData({
                tableCode: TRAINING,
                options: {
                    column: [
                        'NAME',
                        'VIDEO_LINK',
                    ],
                    filter: [{
                        text: '',
                        code: 'DELETED',
                        type: 'null',
                    }, {
                        text: parentSlug,
                        code: 'PARENT_SLUG',
                        type: 'exact',
                    }, {
                        text: slug,
                        code: 'SLUG',
                        type: 'exact',
                    }],
                    filterType: 'and',
                },
            }),
            getData({
                tableCode: TRAINING,
                options: {
                    filter: [{
                        text: '',
                        code: 'DELETED',
                        type: 'null',
                    }, {
                        text: subchapterParentSlug,
                        code: 'PARENT_SLUG',
                        type: 'exact',
                    }],
                    filterType: 'and',
                },
            }),
        ];

        if (parentChapterParentSlug)
            requests.push(
                getData({
                    tableCode: TRAINING,
                    options: {
                        column: [
                            'NAME',
                        ],
                        filter: [{
                            text: '',
                            code: 'DELETED',
                            type: 'null',
                        }, {
                            text: parentChapterParentSlug,
                            code: 'PARENT_SLUG',
                            type: 'exact',
                        }, {
                            text: parentChapterSlug,
                            code: 'SLUG',
                            type: 'exact',
                        }],
                        filterType: 'and',
                    },
                })
            )

        Promise.all(requests).then(res => {
            if (res && res[0] && res[0].success && res[1] && res[1].success && (res[2] && res[2].success || !res[2])) {
                const chapters = sortArray(
                    res[1].data.map((chapter) => {
                        return {
                            id: chapter.ARCIMEDES_ROW_ID,
                            slug: chapter.SLUG,
                            title: chapter.NAME,
                            index: parseInt(chapter.INDEX),
                            img: toMediaUrl(chapter.PHOTO),
                        }
                    }), 'index');

                let previousIndexes = [];
                chapters.map( (ch) =>{ 
                    const id = ch.id; 
                    const index = ch.index;
                    previousIndexes.push({id, index});
                })
                // Guard against a missing chapter row (res[0]) or grandparent row (res[2]) —
                // e.g. brokerage-continuum routes whose TRAINING rows aren't seeded — so we
                // never throw on .data[0] and blank the page.
                const parentChapter = res[0].data[0] || {};
                this.setState({
                    originalChapters: cloneDeep(chapters),
                    chapters,
                    previousIndexes,
                    title: parentChapter.NAME || '',
                    hasVideo,
                    videoLink: parentChapter.VIDEO_LINK || '',
                    backButton: res[2] && res[2].data[0] ? res[2].data[0].NAME : 'TRAINING',
                });
            }
        });
    }

    cancelChanges() {
        const original = cloneDeep(this.state.originalChapters);
        if(newChapter && newChapter.visible)
            this.removePhoto();

        const newChapter = {visible : false};
        this.setState({chapters:original, newChapter, error: null}, this.toggleEdit);
    }

    uploadPhoto(id) {
        const fileName = this.state.uploadedImage.name;
        const base64File = this.state.uploadedImage.base64;
        return uploadFile({fileName, base64File, folder:FOLDER}).then(res => {
            res = res.data.responses[0];
            if (!res || !res.success) {
                if (res.errorCode === existingFileError) {
                        this.setState({
                            uploadedImage: null,
                            error: existingFileErrorMessage
                        });
                } else {
                    this.setState({
                        error: res && res.message ? res.message : "Unspecified error",
                    });
                }
            } else {
                if(!id){
                    const newChapter = {...this.state.newChapter}
                    // newChapter.img holds the bucket-relative path; the edit card
                    // prepends arc.path.media when rendering it.
                    newChapter.img = res.data.path;
                    this.setState({newChapter, error:null});
                } else {
                    let chapters = this.state.chapters;
                    let currentChapter = chapters.find((el) => el.id === id);
                    currentChapter.img = toMediaUrl(res.data.path);
                    this.setState({chapters, error:null});
                }
            }
        })
    }
    // Decided by the member's access level (training.delete).
    canDeleteTraining(){
        return can('training.delete');
    }

    // Ask for confirmation first — the actual removal happens in confirmDeleteCard.
    deleteCard(id){
        if (!this.canDeleteTraining()) return; // not permitted for this user
        this.setState({ pendingDeleteId: id });
    }

    confirmDeleteCard(value){
        const id = this.state.pendingDeleteId;
        if (value !== 'ok' || id === null || id === undefined) {
            this.setState({ pendingDeleteId: null });
            return;
        }
        let chapters = cloneDeep(this.state.chapters);
        chapters = chapters.filter((e)=> e.id != id);
        this.setState({ chapters, pendingDeleteId: null });
    }

    removePhoto(id) {
        // A saved sub-chapter is identified by its row id; the "new chapter" card has none.
        const isExisting = id !== undefined && id !== null && id !== '';
        const chapters = cloneDeep(this.state.chapters);
        // Loose (string) match — ids can arrive as number or string; a strict === here used
        // to leave `chapter` undefined and then throw on `chapter.img`, so the click did
        // nothing (no request).
        const chapter = isExisting ? chapters.find((ch) => String(ch.id) === String(id)) : null;
        const imgUrl = isExisting
            ? (chapter && chapter.img)
            : (this.state.newChapter && this.state.newChapter.img);

        if (isExisting && !chapter) return; // card no longer present
        if (!imgUrl) return;                 // nothing to remove

        // Clear the photo immediately (UI) and, for a saved sub-chapter, persist PHOTO=null.
        // The removal must NOT depend on the physical-file delete succeeding — legacy images
        // live under Arc storage paths the delete API can't reach, which is why nothing
        // happened before.
        if (isExisting) {
            chapter.img = null;
            this.setState({ chapters, error: null });
            manageData({
                tableCode: TRAINING,
                data: [{
                    ARCIMEDES_ROW_ID: chapter.id,
                    PHOTO: null,
                    NAME: chapter.title,
                    INDEX: chapter.index,
                    SLUG: chapter.slug,
                }],
            }).then((res) => {
                if (!res || !res.success) {
                    this.setState({ error: (res && res.message) ? res.message : 'Unspecified error' });
                }
            });
        } else {
            const newChapter = cloneDeep(this.state.newChapter);
            newChapter.img = null;
            this.setState({ uploadedFile: null, newChapter, error: null });
        }

        // Best-effort cleanup of the stored file (fire-and-forget; failures are ignored so
        // they can't block the removal above). Use the real stored filename (last path
        // segment), not a fragile `split('_')`.
        const fileName = imgUrl.split('/').pop();
        if (fileName) {
            removeFile({ fileName, folder: FOLDER + '/' }).catch(() => { /* best-effort */ });
        }
    }

    validateSelectedFile(event, id) {
        const file = event.currentTarget.files[0];
        // Reset so picking the same file again (e.g. after cancelling the crop)
        // still fires onChange.
        event.currentTarget.value = '';
        this.processImageFile(file, id);
    }

    // Accept an image pasted from the clipboard (Ctrl/Cmd+V or a pasted screenshot) and
    // send it through the same upload flow as the file picker. Clipboard images usually
    // arrive without a filename, so we synthesize one (uploadPhoto uses file.name).
    handlePasteImage(event, id) {
        const items = (event.clipboardData && event.clipboardData.items) || [];
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.kind === 'file' && item.type && item.type.indexOf('image') === 0) {
                const blob = item.getAsFile();
                if (blob) {
                    event.preventDefault();
                    const ext = (blob.type.split('/')[1] || 'png').replace('jpeg', 'jpg');
                    const file = blob.name
                        ? blob
                        : new File([blob], `pasted-${Date.now()}.${ext}`, { type: blob.type });
                    this.processImageFile(file, id);
                }
                return;
            }
        }
    }

    processImageFile(selectedFile, id) {
        if (!selectedFile) return;

        const fileSize = selectedFile.size / 1000000; //mb

        if (fileSize > 20){
            this.setState({error:'Maximum file size exceeded'});
            return;
        }
        // SVGs scale to any box, and rasterizing them through the crop canvas
        // would lose that — upload them directly like before.
        const isSvg = selectedFile.type === 'image/svg+xml' || /\.svg$/i.test(selectedFile.name || '');
        getBase64(selectedFile).then(result => {
            if (isSvg) {
                this.setState({
                    uploadedImage: {name: this.stampFileName(selectedFile.name, 'svg'), base64: result}
                }, () => id ? this.uploadPhoto(id) : this.uploadPhoto());
                return;
            }
            this.setState({
                cropper: {src: result, name: selectedFile.name, id},
                error: null
            });
        });
    }

    // The backend stores by filename and overwrites silently, so a re-upload
    // under the same name keeps the same URL and browsers/GCS serve the stale
    // cached image. A timestamp suffix gives every upload a fresh URL.
    stampFileName(originalName, ext) {
        const base = (originalName || 'photo').replace(/\.[^.\/]+$/, '');
        return `${base}-${Date.now()}.${ext}`;
    }

    handleCropConfirm(croppedBase64) {
        const cropper = this.state.cropper;
        if (!cropper) return;
        const ext = croppedBase64.indexOf('data:image/png') === 0 ? 'png' : 'jpg';
        const name = this.stampFileName(cropper.name, ext);
        this.setState({
            uploadedImage: {name, base64: croppedBase64},
            cropper: null
        }, () => cropper.id ? this.uploadPhoto(cropper.id) : this.uploadPhoto());
    }

    handleCropCancel() {
        this.setState({cropper: null});
    }

    render() {
        const {chapters, brokerageChapters, title, hasVideo, videoLink, backButton, isEdit, newChapter, error} = this.state;
        const params = this.props.params || {};
        const topSlug = params.slug || Object.values(params)[0];
        // Editing training follows the member's access level (training.edit); the Brokerage Continuum may be left out.
        const canEdit = canEditTraining(topSlug);
        const activeChapterSlug = params.slug2 || null;
        const isBrokerageContinuum = topSlug === 'brokerage-continuum';
        const chapterColor = getChapterColorBySlug(topSlug);
        const lessonCount = chapters.filter((e) => e.id).length;
        const canDeleteTraining = this.canDeleteTraining();

        return (
            <div className={`ChapterPage${isBrokerageContinuum ? ' ChapterPage--brokerage' : ''}`} style={{'--chapter-color': chapterColor}}>
                <div className='training-chapter-shell'>
                    <nav className='training-breadcrumb'>
                        <LinkComp to={arc.path.base} className='training-breadcrumb__link'>Home</LinkComp>
                        <span className='training-breadcrumb__sep'>/</span>
                        <LinkComp to={`${arc.path.base}training`} className='training-breadcrumb__link'>Training</LinkComp>
                        {backButton && backButton !== 'TRAINING' && (
                            <React.Fragment>
                                <span className='training-breadcrumb__sep'>/</span>
                                <LinkComp to={`${arc.path.base}training/${topSlug}`} className='training-breadcrumb__link'>
                                    {backButton}
                                </LinkComp>
                            </React.Fragment>
                        )}
                        {title && (
                            <React.Fragment>
                                <span className='training-breadcrumb__sep'>/</span>
                                <span className='training-breadcrumb__current'>{title.replace('<br/>', ' ')}</span>
                            </React.Fragment>
                        )}
                    </nav>

                    {!isBrokerageContinuum && (
                        <div className='page-rounded-corner-container'>
                            <div className='page-header-container'>
                                <div className='chapter-hero'>
                                    <div className='chapter-hero__main'>
                                        {/* <div className='chapter-eyebrow'>Course overview</div> */}
                                        <div className='page-header'>
                                            <div className='page-title'>{title}</div>
                                            {
                                                canEdit && isEdit &&
                                                <React.Fragment>
                                                    <div className='button-new negative' onClick={this.cancelChanges}>Cancel</div>
                                                    <div className='button-new positive' onClick={this.saveChanges}>Save</div>
                                                </React.Fragment>
                                            }
                                            {
                                                canEdit && !isEdit &&
                                                <div className='button-new positive' onClick={this.toggleEdit}>Edit</div>
                                            }
                                        </div>
                                        {/* {!isEdit && (
                                            <div className='page-description'>
                                                Work through each lesson in order, or jump to the topic you need most right now. Every lesson is designed to feel short, practical, and easy to revisit.
                                            </div>
                                        )} */}
                                    </div>
                                    <div className='chapter-hero__aside'>
                                        <div className='chapter-stat-card'>
                                            <div className='chapter-stat-card__value'>
                                                {String(lessonCount).padStart(2, '0')}
                                            </div>
                                            <div className='chapter-stat-card__label'>Sections</div>
                                        </div>
                                        {/* <div className='chapter-hero__chips'>
                                            <div className='chapter-chip'>Self-paced</div>
                                            <div className='chapter-chip'>Practical examples</div>
                                            {hasVideo && <div className='chapter-chip'>Includes video</div>}
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {isBrokerageContinuum && (
                        <div className='training-map-container training-map-container--chapter'>
                            <BrokerageMap chapters={brokerageChapters} activeSlug={activeChapterSlug} />
                        </div>
                    )}
                    <div className='page-body-container'>
                        <div className='chapter-section-heading'>
                            <div className='chapter-section-actions' style={{marginLeft: 'auto'}}>
                                {/* On brokerage-continuum pages the hero header (which holds the
                                    Edit/Save controls elsewhere) is replaced by the map, so the
                                    admin controls live here instead. */}
                                {isBrokerageContinuum && canEdit && isEdit && (
                                    <React.Fragment>
                                        <div className='button-new negative' onClick={this.cancelChanges}>Cancel</div>
                                        <div className='button-new positive' onClick={this.saveChanges}>Save</div>
                                    </React.Fragment>
                                )}
                                {isBrokerageContinuum && canEdit && !isEdit && (
                                    <div className='button-new positive' onClick={this.toggleEdit}>Edit</div>
                                )}
                                <button className='button-new action' onClick={() => window.open(`${arc.path.base}print-booklet/${topSlug}/${params.slug2 || params.slug}`, '_blank')}>
                                    Print Section
                                </button>
                            </div>
                        </div>
                        <div className='cards-container'>
                            {
                                chapters.filter((e)=> e.id).map(chapter => (
                                    <SubChapterCard
                                        id={chapter.id}
                                        key={chapter.id}
                                        img={chapter.img}
                                        title={chapter.title}
                                        index={chapter.index}
                                        link={`${this.props.location.pathname}/${chapter.slug}`}
                                        handleParentChange={this.handleInputChange}
                                        handleParentBlur={this.handleInputBlur}
                                        isEdit={isEdit}
                                        error={error}
                                        canDelete={canDeleteTraining}
                                        deleteCard={(id)=>this.deleteCard(id)}
                                        validateSelectedFile={this.validateSelectedFile}
                                        handlePasteImage={this.handlePasteImage}
                                        removePhoto={(id)=>this.removePhoto(id)}
                                    />
                                ))
                            }
                            {/* Video walkthrough card hidden for now
                            {
                                hasVideo &&
                                <SubChapterCard
                                    key='video'
                                    img={arc.path.media + videoImage}
                                    title='Video walkthrough'
                                    link={videoLink}
                                    newWindow
                                />
                            }
                            */}
                            { isEdit &&
                                <SubChapterCard
                                    isNewChapter={true}
                                    newChapter={newChapter}
                                    handleParentChange={this.handleInputChange}
                                    isEdit={isEdit}
                                    error={error}
                                    validateSelectedFile={this.validateSelectedFile}
                                    handlePasteImage={this.handlePasteImage}
                                    removePhoto={(id)=>this.removePhoto(id)}
                                    deleteCard={(id)=>this.deleteCard(id)}
                                    addNewChapter={() => this.setState({newChapter:{visible:true}})}
                                />
                            }
                        </div>
                    </div>
                </div>
                <ConfirmationDialog
                    open={this.state.pendingDeleteId != null}
                    onClose={this.confirmDeleteCard}
                    content="Are you sure you want to delete this training?"
                    style={{ zIndex: 10002 }}
                />
                <ImageCropperDialog
                    open={this.state.cropper != null}
                    src={this.state.cropper ? this.state.cropper.src : null}
                    onCancel={this.handleCropCancel}
                    onConfirm={this.handleCropConfirm}
                    style={{ zIndex: 10002 }}
                />
            </div>
        )
    }
}